import React from "react";
import { DtoRoutesDefinition } from "../Dto/auth";

import LoginPage from "../Pages/AuthPages/LoginPage";
import UserManagement from "../Pages/HomePages/UserManagement";
import UserView from "../Pages/HomePages/UserView";
import TagManagement from "../Pages/HomePages/TagManagement";
import LocationManagement from "../Pages/HomePages/LocationManagement";
// import Property from "../Pages/property/property";
import DashBoard from "../Pages/Dashboard/dashboard";
import ResetPassword from "../Pages/AuthPages/ResetPassword";
import RolePages from "../Pages/RolePages/rolePages";
import { Navigate } from "react-router-dom";
import Sports from "../Pages/Sports/sports";
import SportsDetail from "../Pages/Sports/SportsDetail";
import PostManagement from "../Pages/postPages/postsManagement";
import PostDetail from "../Pages/postPages/postDetail";
import PlayerManagement from "../Pages/PlayerManagement/PlayerManagement";

export const ProtectedRoutes: DtoRoutesDefinition[] = [
  {
    path: "/",
    element: <Navigate to="/dashboard" replace />,
    modules: ["view_users", "manage_users"],
  },
  {
    path: "/dashboard",
    element: <DashBoard />,
    modules: ["view_users", "manage_users"],
  },
  {
    path: "/user",
    element: <UserManagement />,
    permission: ["view_users", "manage_users"],
    modules: ["view_users", "manage_users"],
  },
  {
    path: "/user/:id",
    element: <UserView />,
    permission: ["view_users"],
    modules: ["view_users"]
  },
  {
    path: "/tag",
    element: <TagManagement />,
    permission: ["view_tags", "manage_tags"],
    modules: ["view_tags", "manage_tags"]
  },
  {
    path: "/location",
    element: <LocationManagement />,
    permission: ["view_locations", "manage_locations"],
    modules: ["view_locations", "manage_locations"]
  },
  {
    path: "/roles",
    element: <RolePages />,
    permission: ["view_roles", "manage_roles"],
    modules: ["view_roles", "manage_roles"],
  },
  {
    path: "/sports",
    element: <Sports />,
    permission: ["view_sports", "manage_sports"],
    modules: ["view_sports", "manage_sports"],
  },
  {
    path: "/posts",
    element: <PostManagement />,
    permission: ["view_posts", "manage_posts"],
    modules: ["view_posts", "manage_posts"],
  },
  {
    path: "/posts/:id",
    element: <PostDetail />,
    permission: ["view_posts", "manage_posts"],
    modules: ["view_posts", "manage_posts"],
  },
  {
    path: "/sports/:id",
    element: <SportsDetail />,
    permission: ["view_sports", "manage_sports"],
    modules: ["view_sports", "manage_sports"],
  },
  {
    path: "/player-management",
    element: <PlayerManagement />,
    permission: ["view_players", "manage_players"],
    modules: ["view_players", "manage_players"],
  },
];

export const AuthRoutes: DtoRoutesDefinition[] = [
  {
    path: "/sign-in",
    element: <LoginPage />,
  },
  {
    path: "/sign-up",
    element: <></>,
  },
  {
    path: "/reset-password/:id",
    element: <ResetPassword />,
  },
];
